import type { GameMeta } from "@kit/meta";

export const meta: GameMeta = {
  id: "blok",
  name: "Blok",
  tagline: "Blokları yerleştir, satırları patlat; altındaki gizli resmi ne kadar az parçada bilirsin?",
  inspiredBy: "Block Blast!",
  secondLayer: "Bilgi: temizlediğin her kare gizli resmin bir parçasını açar; resmi tahmin et",
  accent: "#1982c4",
  status: "lab",
};
